import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

// Components
import Spinner from "../Components/Spinner";
import MessageModal from "../Components/Modals/MessageModal";

// Services
import { vehicleService } from "../../Services/vehicle.service";
import { toDateTime } from "../../Services/string.service";

// Icons
import { IoIosMail } from "react-icons/io";
import { IoIosMailOpen } from "react-icons/io";
import { IoIosMailUnread } from "react-icons/io";

// Constants
const _pageTitle = "Detalhes de Indicadores";
const _listTitle = "Mensagens";

export default function MessageDetails() {

    const dispatch = useDispatch();
    dispatch({ type: "title", value: _pageTitle });

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [modalParams, setModalParams] = useState({});

    const fetchIndicators = async () => {
        console.log('🐗: fetchIndicators');

        setLoading(true);

        try {

            var result = await vehicleService.fetchVehicleMessagesIndicatorDetails();

            console.log("Resultado fetchVehicleMessagesIndicatorDetails:");
            console.log(result?.result);

            if (result?.result)
                setData(result?.result);

        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }

    };

    const handleCloseModal = () => {
        setModalParams({ show: false });
    };

    const handleMessage = (read, id) => {
        const message = "Deseja marcar a mensagem como " + (read == "S" ? "lida" : "não lida") + "?";
        setModalParams({ show: true, message, read, id });
    };

    const callBackHandleMessage = async(params) => { 
        console.log("params");
        console.log(params);

        try {
            var response = await vehicleService.defineReadMessage(params.id, params.read);

            console.log("Response de defineReadMessage");
            console.log(response);
        } catch (error) {
            console.error(error);
        }

        await fetchIndicators();
    };

    useEffect(() => {
        (async () => {
            await fetchIndicators();
        })();
    }, []);


    return (
        <>
            <div className='container-xxl flex-grow-1 container-p-y'>

                {loading ? <Spinner /> : ""}

                <MessageModal
                    params={modalParams}
                    callBack={callBackHandleMessage}
                    show={modalParams.show}
                    handleClose={handleCloseModal}
                />


                <div style={loading ? { display: "none" } : { display: "" }} className="col-md-8 col-lg-8 order-2 mb-4">
                    <div className="card h-100">
                        <div className="card-header d-flex align-items-center justify-content-between">
                            <h5 className="card-title m-0 me-2"><IoIosMail size={25} /> {_listTitle}</h5>
                        </div>
                        <div className="card-body">
                            <ul className="p-0 m-0">


                                {data.map((item, index) => (

                                    <li className="d-flex mb-4 pb-1" key={index}>
                                        <div className="avatar flex-shrink-0 me-3">
                                            {item.markedAsRead?.toUpperCase() == "S" ? (
                                                <IoIosMailOpen size={23} style={{ color: 'red', cursor: 'pointer' }} onClick={async () => handleMessage("N", item.notificationId)} />
                                            ) : (<IoIosMailUnread size={23} style={{ color: 'green', cursor: 'pointer' }} onClick={async () => handleMessage("S", item.notificationId)} />)}

                                        </div>
                                        <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                            <div className="me-2">
                                                <h6 className="mb-0">{item.message}</h6>
                                            </div>
                                            <div className="user-progress d-flex align-items-center gap-1">
                                                <span className="text-muted">{toDateTime(item.generationTime)}</span>
                                            </div>
                                        </div>
                                    </li>
                                ))}

                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};